import React, { Component } from 'react';
import CommonSubHeader from '../../SubHeader';
import { inject, observer } from 'mobx-react';
import AirButton from '../../../../common/components/AirButton';
import CreateOrder from "./CreateOrder";

import './SubHeader.css';

@inject('translationsStore', 'authStore')
@observer
export default class SubHeader extends Component {
  constructor(props) {
    super(props);
    this.CreateOrderRef = React.createRef();
  }

  componentDidMount = () => {
    this.CreateOrderInstance = this.CreateOrderRef.current.wrappedInstance;
  };

  render() {
    const { translationsStore, authStore } = this.props;
    return (
      <CommonSubHeader className="OrderSubHeader">
        {(authStore.isServiceManager && (
          <AirButton
            onClick={() => this.CreateOrderInstance.show()}
            size="large"
            label={translationsStore.translate('order.addNew')}
          />
        ))}
        <CreateOrder ref={this.CreateOrderRef} width={560} />
      </CommonSubHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/OrdersManagerDashboard/SubHeader/SubHeader.js